import { IconBadgeMedal } from "assets/svg";
import React from "react";
import type { SellerPublicCardBadge } from "reducers/companyProfileApi";
import {
  getBadgePublicAssetUrl,
  getPublicAssetUrl,
} from "./productSellerCompanyCard.utils";
import { useHorizontalDragScroll } from "./useHorizontalDragScroll";

interface ProductSellerBadgeListProps {
  badges: SellerPublicCardBadge[];
}

const ProductSellerBadgeList = ({ badges }: ProductSellerBadgeListProps) => {
  const {
    handlePointerDown,
    handlePointerMove,
    handlePointerUp,
    handleWheel,
    isDragging,
    scrollRef,
  } = useHorizontalDragScroll();

  return (
    <div
      ref={scrollRef}
      onWheel={handleWheel}
      onPointerDown={handlePointerDown}
      onPointerLeave={handlePointerUp}
      onPointerUp={handlePointerUp}
      onPointerCancel={handlePointerUp}
      onPointerMove={handlePointerMove}
      className={`scrollbar-hide flex h-20 select-none items-center overflow-x-auto overflow-y-hidden rounded-md bg-[#f5f5f5] px-2.5 sm:h-[100px] sm:px-[15px] ${
        isDragging ? "cursor-grabbing" : "cursor-grab"
      }`}
    >
      {badges.length > 0 ? (
        <div className="flex min-w-max gap-[10px]">
          {badges.map((badge) => (
            <div
              key={badge.id}
              title={badge.name}
              className="flex h-[50px] w-[50px] shrink-0 items-center justify-center sm:h-[60px] sm:w-[60px]"
            >
              {badge.icon_url ? (
                <img
                  src={getPublicAssetUrl(
                    badge.code
                      ? getBadgePublicAssetUrl(badge.code)
                      : badge.icon_url,
                  )}
                  alt={badge.name}
                  draggable={false}
                  className="h-full w-full object-contain"
                />
              ) : (
                <div className="flex h-full w-full items-center justify-center rounded-full bg-white">
                  <IconBadgeMedal className="h-[44px] w-[44px] text-primary" />
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <span className="w-full text-center text-[14px] text-[#999999]">
          獲得バッジはありません
        </span>
      )}
    </div>
  );
};

export default ProductSellerBadgeList;
